/* eslint-disable import/prefer-default-export */
import {
  AccessParams,
  AccessLevelOptions,
  AccessLevel,
  FeatureFlagAccessResponse,
} from './types';

// --------------------------------   helper functions ------------------------------------------------------------
const checkAccessByLevel = (
  userAccess: Record<string, { has_access: boolean }>,
  level: AccessLevel,
  params: AccessParams,
): boolean => {
  const accessLevelMap = {
    [AccessLevelOptions.COURSE]: params.courseId,
    [AccessLevelOptions.SECTION]: params.sectionId,
    [AccessLevelOptions.ORGANIZATION]: params.organizationId,
    [AccessLevelOptions.DISTRICT]: params.districtId,
    [AccessLevelOptions.USER]: params.userId,
  };

  const id = accessLevelMap[level];
  if (!id) {
    return false;
  }
  return !!userAccess[id || '']?.has_access;
};

export const checkUserAccess = (
  data: FeatureFlagAccessResponse,
  params: AccessParams,
) => {
  if (!data) {
    return false;
  }
  const { user_access: userAccess, level } = data;

  if (!userAccess) {
    return false;
  }

  return checkAccessByLevel(userAccess, level as AccessLevel, params);
};
